import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { NavController } from '@ionic/angular';
import { ApiService } from '../services/api.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(public authService: AuthService, private apiService: ApiService, private router: Router) {}

  async canActivate(): Promise<any> {
    const isAuth = localStorage.getItem('token');
    let elu: any = localStorage.getItem('elu');

    elu = JSON.parse(elu) as Object;
    if (isAuth) {
      return true;
    }
    
    this.router.navigate(['/public']);
    return false;
  }
}
